
export interface Testimonial {
  id: number;
  text: string;
  name: string;
  handle: string;
  postedAt?: string;
  avatarSrc: string;
  profit?: string;
  imageSrc?: string;
  aspectRatio?: string;
  tier: "high" | "mid" | "standard";
}

export function getDisplayAspectRatio(width: number, height: number): string {
  const nativeRatio = width / height;

  if (nativeRatio < 0.8) {
    return "4/5";
  } else if (nativeRatio > 2) {
    return "2/1";
  } else {
    return `${width}/${height}`;
  }
}

export const ALL_TESTIMONIALS: Testimonial[] = [
  {
    id: 2,
    imageSrc: "/images/sportsbooks/REVIEW_TJ_DEC.webp",
    avatarSrc: "/images/sportsbooks/id_tj.webp",
    text: "December 2025: $8,900+ profits. All thanks to @UpsideTools and their software. It's easy to profit when you have the right tools.",
    name: "TJ Jordan",
    handle: "@thomasjordaniv",
    profit: "+$8,900",
    aspectRatio: getDisplayAspectRatio(900, 900),
    tier: "high",
  },
  {
    id: 1,
    imageSrc: "/images/sportsbooks/REVIEW_BG_1.webp",
    avatarSrc: "/images/sportsbooks/id_bg.webp",
    text: "Ended December up $1400. Ended 2025 up $6700. S/O to @UpsideTools - this tool has helped me lock in and find value across multiple DFS apps.",
    name: "BG",
    handle: "@BG__bets",
    profit: "+$6,700",
    aspectRatio: getDisplayAspectRatio(680, 383),
    tier: "high",
  },
  {
    id: 35,
    imageSrc: "/images/sportsbooks/REVIEW_JUL_MATT_25X.webp",
    avatarSrc: "/images/sportsbooks/id_PlusEV.webp",
    text: "OMFGGG BANG! Cash the 25X on PrizePicks. The new +EV Sniper on @UpsideTools is so goated!",
    name: "Matt Downs",
    handle: "@PlusEV",
    postedAt: "Jul 2026",
    profit: "25x",
    aspectRatio: getDisplayAspectRatio(544, 1200),
    tier: "high",
  },
  {
    id: 36,
    imageSrc: "/images/sportsbooks/REVIEW_JUL_BG_185X.webp",
    avatarSrc: "/images/sportsbooks/id_BG__bets.webp",
    text: "Back from Hawaii and we hit those! 18.5x secured from @UpsideTools. Let me see those winners!",
    name: "BG",
    handle: "@BG__bets",
    postedAt: "Jul 2026",
    profit: "18.5x",
    aspectRatio: getDisplayAspectRatio(1125, 864),
    tier: "high",
  },
  {
    id: 37,
    imageSrc: "/images/sportsbooks/REVIEW_JUL_EJ_940.webp",
    avatarSrc: "/images/sportsbooks/id_EarlyJuice.webp",
    text: "This isn't a brag post. It's proof: $940 in the last 7 days. Same $10 bets I've always made. @UpsideTools",
    name: "EJ",
    handle: "@EarlyJuice__",
    postedAt: "Jul 2026",
    profit: "+$940",
    aspectRatio: getDisplayAspectRatio(768, 1075),
    tier: "high",
  },
  {
    id: 38,
    imageSrc: "/images/sportsbooks/REVIEW_JUN_ERIC_487U.webp",
    avatarSrc: "/images/sportsbooks/id_ericallred4.webp",
    text: "After a couple bumps, saw our best day across the apps. +48.7u and up 133% MTD. All plays found using @UpsideTools.",
    name: "Eric Allred",
    handle: "@ericallred4",
    postedAt: "Jun 2026",
    profit: "+48.7u",
    aspectRatio: getDisplayAspectRatio(613, 1200),
    tier: "high",
  },
  {
    id: 7,
    imageSrc: "/images/sportsbooks/REVIEW2.webp",
    avatarSrc: "/images/sportsbooks/id2.webp",
    text: "Still had great betting month using @UpsideTools and copying other profitable sports bettors. Let's hope December is just as good!",
    name: "Pac10",
    handle: "@Reboundrr",
    profit: "+$3,117",
    aspectRatio: getDisplayAspectRatio(1020, 1610),
    tier: "high",
  },
  {
    id: 9,
    imageSrc: "/images/sportsbooks/REVIEW5.webp",
    avatarSrc: "/images/sportsbooks/id5.webp",
    text: "@UpsideTools is literally goated. Not bad not bad.",
    name: "Matt Downs",
    handle: "@cmattdowns",
    profit: "+$2,876",
    aspectRatio: getDisplayAspectRatio(1135, 677),
    tier: "mid",
  },
  {
    id: 40,
    imageSrc: "/images/sportsbooks/REVIEW_JUL_ICON_75X_6X.webp",
    avatarSrc: "/images/sportsbooks/id_IconBetsVIP.webp",
    text: "Two Betr cashes from the stream: 7.5x and 6x. Kinda in love with @UpsideTools.",
    name: "Icon",
    handle: "@IconBetsVIP",
    postedAt: "Jul 2026",
    profit: "7.5x + 6x",
    aspectRatio: getDisplayAspectRatio(1047, 1200),
    tier: "mid",
  },
  {
    id: 42,
    imageSrc: "/images/sportsbooks/REVIEW_JUL_DOUBLEBB_430X.webp",
    avatarSrc: "/images/sportsbooks/id_DooubleBB.webp",
    text: "Cash this for a 4.30x. S/o to @UpsideTools on the sharp read.",
    name: "DoubleBB",
    handle: "@DooubleBB",
    postedAt: "Jul 2026",
    profit: "4.30x",
    aspectRatio: getDisplayAspectRatio(1075, 1063),
    tier: "mid",
  },
  {
    id: 41,
    imageSrc: "/images/sportsbooks/REVIEW_JUL_DOUBLEBB_6X.webp",
    avatarSrc: "/images/sportsbooks/id_DooubleBB.webp",
    text: "Cash another 6x. S/o to @UpsideTools—this is goated!",
    name: "DoubleBB",
    handle: "@DooubleBB",
    postedAt: "Jul 2026",
    profit: "6x",
    aspectRatio: getDisplayAspectRatio(1078, 1200),
    tier: "mid",
  },
  {
    id: 43,
    imageSrc: "/images/sportsbooks/REVIEW_JUL_ALEX_5SEC.webp",
    avatarSrc: "/images/sportsbooks/id_Cinematicc.webp",
    text: "Nice little sweat-free winner on ProphetX. It literally took me 5 seconds to find this profitable play using @UpsideTools.",
    name: "Alex",
    handle: "@Cinematicc",
    postedAt: "Jul 2026",
    profit: "5-sec Find",
    aspectRatio: getDisplayAspectRatio(1200, 662),
    tier: "standard",
  },
  {
    id: 44,
    imageSrc: "/images/sportsbooks/REVIEW_JUL_DT_BOOSTED.webp",
    avatarSrc: "/images/sportsbooks/id_daviddailydfs.webp",
    text: "Turned the day around with this boosted cash. Shoutout @UpsideTools for the Bradish play on Whale Watch!",
    name: "DT",
    handle: "@daviddailydfs_",
    postedAt: "Jul 2026",
    profit: "Boosted Cash",
    aspectRatio: getDisplayAspectRatio(1200, 748),
    tier: "standard",
  },
  {
    id: 45,
    imageSrc: "/images/sportsbooks/REVIEW_JUL_BG_SLEEPER.webp",
    avatarSrc: "/images/sportsbooks/id_BG__bets.webp",
    text: "Cash both Sleeper discounts! @UpsideTools Whale Watch is 100% goated.",
    name: "BG",
    handle: "@BG__bets",
    postedAt: "Jul 2026",
    profit: "2x Cash",
    aspectRatio: getDisplayAspectRatio(995, 1200),
    tier: "standard",
  },
  {
    id: 46,
    imageSrc: "/images/sportsbooks/REVIEW_JUL_SWAMP_DABBLE.webp",
    avatarSrc: "/images/sportsbooks/id_brady_swampy14.webp",
    text: "Just here to show it cashed. @UpsideTools has been showing great value on Dabble lately.",
    name: "Swamp",
    handle: "@brady_swampy14",
    postedAt: "Jul 2026",
    profit: "Dabble Cash",
    aspectRatio: getDisplayAspectRatio(918, 1200),
    tier: "standard",
  },
  {
    id: 39,
    imageSrc: "/images/sportsbooks/REVIEW_JUL_COACH_MONTHS.webp",
    avatarSrc: "/images/sportsbooks/id_SlipStreamEdge.webp",
    text: "If you've been waiting to see if @UpsideTools is profitable, compare these two months: June with Upside versus January before I started using it.",
    name: "Coach Koogs",
    handle: "@SlipStreamEdge",
    postedAt: "Jul 2026",
    profit: "Before vs. After",
    aspectRatio: getDisplayAspectRatio(768, 1075),
    tier: "standard",
  },
  {
    id: 3,
    imageSrc: "/images/sportsbooks/REVIEW10.webp",
    avatarSrc: "/images/sportsbooks/id8.webp",
    text: "Day 3 using +EV optimizer. Hit two 10x's two 6x's and a 5x on Dabble. Hit four 6x's on Betr. Hit two 6x's on PrizePicks. S/O @UpsideTools for spotting all of the value and making it easy to be profitable!",
    name: "Blake",
    handle: "@blakeprops",
    profit: "5x 10x",
    aspectRatio: getDisplayAspectRatio(1440, 1920),
    tier: "standard",
  },
  {
    id: 4,
    imageSrc: "/images/sportsbooks/REVIEW6.webp",
    avatarSrc: "/images/sportsbooks/id6.webp",
    text: "I took 12 slips on Dabble tonight\u2026 I HIT EIGHT OF THEM. @UpsideTools YOU'RE GOATED. I've barely had the tool for 24 hours\u2026",
    name: "Boonegan",
    handle: "@bboonegan1249",
    profit: "8/12 Hits",
    aspectRatio: getDisplayAspectRatio(1284, 1557),
    tier: "standard",
  },
  {
    id: 8,
    imageSrc: "/images/sportsbooks/REVIEW4.webp",
    avatarSrc: "/images/sportsbooks/id4.webp",
    text: "Another solid day yesterday! 7-1 over on Novig. 2 10x on Pick6. The amount of winners we gave out on stream was bananas!",
    name: "TJ Jordan",
    handle: "@thomasjordaniv",
    profit: "+$1,002",
    aspectRatio: "1179/476",
    tier: "mid",
  },
  {
    id: 5,
    imageSrc: "/images/sportsbooks/REVIEW9.webp",
    avatarSrc: "/images/sportsbooks/id7.webp",
    text: "Real quick, just wanted to show you some sweats I'm waiting on this weekend. All using the @UpsideTools. Can't tell you guys enough how great this tool is. You don't need to know sports to use this, honestly my 12 year old can do it.",
    name: "Jamie",
    handle: "@JamieEJames17",
    profit: "Live Bets",
    aspectRatio: getDisplayAspectRatio(1161, 1583),
    tier: "standard",
  },
  {
    id: 6,
    imageSrc: "/images/sportsbooks/REVIEW7.webp",
    avatarSrc: "/images/sportsbooks/id1.webp",
    text: "I'm up almost 1K halfway thru the month. Finding consistent edges & sniping value is so easy with @UpsideTools. Don't sleep on the +EV Optimizer!",
    name: "Miles",
    handle: "@milesofdata_",
    profit: "+$1K",
    aspectRatio: getDisplayAspectRatio(1170, 1739),
    tier: "mid",
  },
  {
    id: 12,
    imageSrc: "/images/sportsbooks/REVIEW3.webp",
    avatarSrc: "/images/sportsbooks/id3.webp",
    text: "Decent day. Thank you @UpsideTools. Small slate tomorrow there's still value to hunt though\u2026",
    name: "Alex",
    handle: "@ItsCinematicc",
    profit: "+$1,032",
    aspectRatio: getDisplayAspectRatio(1197, 664),
    tier: "mid",
  },
  {
    id: 10,
    imageSrc: "/images/sportsbooks/REVIEW1.webp",
    avatarSrc: "/images/sportsbooks/id1.webp",
    text: "Cashed 2 10x's yesterday w/ +EV props from @UpsideTools. Entered these slips in the airport waiting to board my flight!",
    name: "Miles",
    handle: "@milesofdata_",
    profit: "2x 10x",
    aspectRatio: getDisplayAspectRatio(1245, 2048),
    tier: "standard",
  },
  {
    id: 11,
    imageSrc: "/images/sportsbooks/REVIEW8.webp",
    avatarSrc: "/images/sportsbooks/id2.webp",
    text: "Thanks to @thomasjordaniv I've been on a heater this month using the @UpsideTools +EV optimizer and copying other profitable bettors.",
    name: "Pac10",
    handle: "@Reboundrr",
    profit: "Heater",
    aspectRatio: getDisplayAspectRatio(1020, 1610),
    tier: "standard",
  },
  {
    id: 14,
    imageSrc: "/images/sportsbooks/REVIEW_DT_1035.webp",
    avatarSrc: "/images/sportsbooks/id_daviddailydfs.webp",
    text: "3 BIG CASHES FOR TWITTER! $140 to $1035.69. The @betr boosted slip will be a W once it settles! Also hit the boosted slip WITH purple on @Pick6. @UpsideTools making it easy.",
    name: "DT",
    handle: "@daviddailydfs",
    profit: "+$1,035",
    aspectRatio: getDisplayAspectRatio(1125, 944),
    tier: "high",
  },
  {
    id: 15,
    imageSrc: "/images/sportsbooks/REVIEW_MATT_6X.webp",
    avatarSrc: "/images/sportsbooks/id_PlusEV.webp",
    text: "Bang... BANG. Cash these two 6Xs as well. S/O to the sharps on Whale Watch that have been setting these lines @UpsideTools. Scoot Henderson adjusted TWO points after we sniped that value.",
    name: "Matt Downs",
    handle: "@PlusEV",
    profit: "2x 6x",
    aspectRatio: getDisplayAspectRatio(1054, 1250),
    tier: "mid",
  },
  {
    id: 16,
    imageSrc: "/images/sportsbooks/REVIEW_MATT_500.webp",
    avatarSrc: "/images/sportsbooks/id_PlusEV.webp",
    text: "Cash this 4.25X. We made like $500+ from UD alone yesterday. So many winners to tweet out. S/O @UpsideTools for pointing out the crazy value on these.",
    name: "Matt Downs",
    handle: "@PlusEV",
    profit: "+$500",
    aspectRatio: getDisplayAspectRatio(1179, 1520),
    tier: "mid",
  },
  {
    id: 13,
    imageSrc: "/images/sportsbooks/REVIEW_DT_CHEATCODE.webp",
    avatarSrc: "/images/sportsbooks/id_daviddailydfs.webp",
    text: "Man, the @UpsideTools optimizer is such a cheat code. Betr 20x and a couple UD trial run slips.",
    name: "DT",
    handle: "@daviddailydfs",
    profit: "20x",
    aspectRatio: getDisplayAspectRatio(1180, 650),
    tier: "mid",
  },
  {
    id: 22,
    imageSrc: "/images/sportsbooks/REVIEW_TJ_10X_PICK6.webp",
    avatarSrc: "/images/sportsbooks/id_thomasjordaniv.webp",
    text: "Live stream BANG! $20 to $200. Another 10x winner on Pick6. Thank you @UpsideTools for the value on this slip!",
    name: "TJ Jordan",
    handle: "@thomasjordaniv",
    profit: "10x",
    aspectRatio: getDisplayAspectRatio(1179, 652),
    tier: "mid",
  },
  {
    id: 18,
    imageSrc: "/images/sportsbooks/REVIEW_PAZ_72X.webp",
    avatarSrc: "/images/sportsbooks/id_PazPickz.webp",
    text: "DABBLE 7.2x! Insane slip here as we are getting a boosted multiplier on Wemby's blocks. Couldn't find these plays without @UpsideTools!",
    name: "Pa'z Pickz",
    handle: "@PazPickz",
    profit: "7.2x",
    aspectRatio: getDisplayAspectRatio(1110, 1489),
    tier: "mid",
  },
  {
    id: 21,
    imageSrc: "/images/sportsbooks/REVIEW_COOP_10X.webp",
    avatarSrc: "/images/sportsbooks/id_Coop_UST.webp",
    text: "KAT Betr Discount 10x Slip. All props came directly from the @UpsideTools Fantasy Player Props Optimizer Tool.",
    name: "Coop",
    handle: "@Coop_UST",
    profit: "10x",
    aspectRatio: getDisplayAspectRatio(1170, 1896),
    tier: "mid",
  },
  {
    id: 24,
    imageSrc: "/images/sportsbooks/REVIEW_BG_WHALE.webp",
    avatarSrc: "/images/sportsbooks/id_BG__bets.webp",
    text: "CBB 76% BOOST ALL FROM THE @UpsideTools WHALE WATCH TOOL.",
    name: "BG",
    handle: "@BG__bets",
    profit: "76% Boost",
    aspectRatio: getDisplayAspectRatio(1125, 864),
    tier: "mid",
  },
  {
    id: 17,
    imageSrc: "/images/sportsbooks/REVIEW_PAZ_425.webp",
    avatarSrc: "/images/sportsbooks/id_PazPickz.webp",
    text: "4.25x UD CASH. Underdog's new payouts and the squad boosts have made it such an amazing app. S/o @UpsideTools as always for pointing out the value!",
    name: "Pa'z Pickz",
    handle: "@PazPickz",
    profit: "4.25x",
    aspectRatio: getDisplayAspectRatio(1179, 1452),
    tier: "standard",
  },
  {
    id: 19,
    imageSrc: "/images/sportsbooks/REVIEW_ALEX_CASH.webp",
    avatarSrc: "/images/sportsbooks/id_Cinematicc.webp",
    text: "CASHHHH. I love these new payouts. S/o @UpsideTools for the value.",
    name: "Alex",
    handle: "@Cinematicc",
    profit: "Cash",
    aspectRatio: getDisplayAspectRatio(1179, 1392),
    tier: "standard",
  },
  {
    id: 20,
    imageSrc: "/images/sportsbooks/REVIEW_PANDA_CASH.webp",
    avatarSrc: "/images/sportsbooks/id_PandaSmush83.webp",
    text: "Cashed this 4 man unders using the @UpsideTools app.",
    name: "PandaSmush",
    handle: "@PandaSmush83",
    profit: "4-man Cash",
    aspectRatio: getDisplayAspectRatio(1170, 1575),
    tier: "standard",
  },
  {
    id: 23,
    imageSrc: "/images/sportsbooks/REVIEW_DT_BANG.webp",
    avatarSrc: "/images/sportsbooks/id_daviddailydfs.webp",
    text: "Bang! Another UD cash. Gonna keep pumping out UD slips as long as there's value on @UpsideTools.",
    name: "DT",
    handle: "@daviddailydfs",
    profit: "UD Cash",
    aspectRatio: getDisplayAspectRatio(1179, 1496),
    tier: "standard",
  },
  {
    id: 25,
    imageSrc: "/images/sportsbooks/REVIEW_PAZ_325X.webp",
    avatarSrc: "/images/sportsbooks/id_PazPickz.webp",
    text: "32.5x BANG! I REALLY DID IT AGAIN. Not sure if anyone has been handing out FREE 6 man winners like I have lately, so if you've tailed at all, I hope it's been profitable for you!",
    name: "Pa'z Pickz",
    handle: "@PazPickz",
    profit: "32.5x",
    aspectRatio: getDisplayAspectRatio(1114, 821),
    tier: "high",
  },
  {
    id: 26,
    imageSrc: "/images/sportsbooks/REVIEW_BRADY_40X.webp",
    avatarSrc: "/images/sportsbooks/id_brady_swampy14.webp",
    text: "CBB ALL UNDERS. Prizepicks 40x using @UpsideTools optimizer.",
    name: "Brady",
    handle: "@brady_swampy14",
    profit: "40x",
    aspectRatio: getDisplayAspectRatio(855, 2048),
    tier: "high",
  },
  {
    id: 27,
    imageSrc: "/images/sportsbooks/REVIEW_MATT_TWO6X.webp",
    avatarSrc: "/images/sportsbooks/id_PlusEV.webp",
    text: "Bang... BANG. Cash these two 6Xs as well. S/O to the sharps on Whale Watch that have been setting these lines @UpsideTools.",
    name: "Matt Downs",
    handle: "@PlusEV",
    profit: "2x 6x",
    aspectRatio: getDisplayAspectRatio(1054, 1250),
    tier: "mid",
  },
  {
    id: 28,
    imageSrc: "/images/sportsbooks/REVIEW_TJ_6X_PP.webp",
    avatarSrc: "/images/sportsbooks/id_thomasjordaniv.webp",
    text: "6x BANG! Cash the PrizePicks slip baby! Love that we locked this in earlier in the week and it paid off. Thank you @UpsideTools Fantasy Player Props Optimizer!",
    name: "TJ Jordan",
    handle: "@thomasjordaniv",
    profit: "6x",
    aspectRatio: getDisplayAspectRatio(1179, 1283),
    tier: "mid",
  },
  {
    id: 29,
    imageSrc: "/images/sportsbooks/REVIEW_MATT_6X_ESPORTS.webp",
    avatarSrc: "/images/sportsbooks/id_PlusEV.webp",
    text: "Cash the 6X. Hit the PrizePicks side of the middle. S/O @UpsideTools for the Esports discrepancy tool. Anyone else tail this?",
    name: "Matt Downs",
    handle: "@PlusEV",
    profit: "6x Cash",
    aspectRatio: getDisplayAspectRatio(1136, 1258),
    tier: "mid",
  },
  {
    id: 30,
    imageSrc: "/images/sportsbooks/REVIEW_TYLER_PICK6.webp",
    avatarSrc: "/images/sportsbooks/id_TylerWalker21.webp",
    text: "Starting out strong coming back from the break. Player prop optimizer did it again for me and cashed me out on @Pick6 for my favorite color. Promo code TYLER for 25% off!",
    name: "Tyler Walker",
    handle: "@TylerWalker21",
    profit: "Pick6 Cash",
    aspectRatio: getDisplayAspectRatio(1244, 1677),
    tier: "mid",
  },
  {
    id: 31,
    imageSrc: "/images/sportsbooks/REVIEW_PAC10_MULTI.webp",
    avatarSrc: "/images/sportsbooks/id_Reboundr_.webp",
    text: "BANG! Cashed all these slips using @UpsideTools Optimizer and Whale Watch Tool. I posted out all these slips for FREE! Betr 20x, Pick6 10x, and more.",
    name: "Pac10",
    handle: "@Reboundr_",
    profit: "20x + 10x",
    aspectRatio: getDisplayAspectRatio(1125, 840),
    tier: "mid",
  },
  {
    id: 32,
    imageSrc: "/images/sportsbooks/REVIEW_76ERS_ENDORSE.webp",
    avatarSrc: "/images/sportsbooks/id_76ersW_.webp",
    text: "Bettors need to use @UpsideTools. S/o @thomasjordaniv and @PlusEV.",
    name: "76ers W",
    handle: "@76ersW_",
    profit: "Endorsed",
    aspectRatio: getDisplayAspectRatio(1170, 2823),
    tier: "standard",
  },
  {
    id: 33,
    imageSrc: "/images/sportsbooks/REVIEW_DBURGY_EVERY_APP.webp",
    avatarSrc: "/images/sportsbooks/id_dburgy422.webp",
    text: "NBA is back! Cashing on every app thanks to @UpsideTools. Stop doing research and let the sportsbooks do it for you!",
    name: "DBurgy",
    handle: "@dburgy422",
    profit: "Multi Cash",
    aspectRatio: getDisplayAspectRatio(1179, 1189),
    tier: "standard",
  },
  {
    id: 34,
    imageSrc: "/images/sportsbooks/REVIEW_INFORM_PROFITABLE.webp",
    avatarSrc: "/images/sportsbooks/id_informessential.webp",
    text: "Bang Bang. Thanks fellas. One pay and you're made profitable. Sweat free, isn't small size to test. @UpsideTools making it easy.",
    name: "Inform Essential",
    handle: "@informessential",
    profit: "Profitable",
    aspectRatio: getDisplayAspectRatio(1170, 812),
    tier: "standard",
  },
];

export const PRICING_TESTIMONIALS: Testimonial[] = [
  ALL_TESTIMONIALS.find((t) => t.id === 1)!,
  ALL_TESTIMONIALS.find((t) => t.id === 4)!,
  ALL_TESTIMONIALS.find((t) => t.id === 2)!,
];

export const CHECKOUT_TESTIMONIAL: Testimonial = ALL_TESTIMONIALS.find((t) => t.id === 7)!;

export const INTERSTITIAL_TESTIMONIALS: Testimonial[] = [
  ALL_TESTIMONIALS.find((t) => t.id === 2)!,
  ALL_TESTIMONIALS.find((t) => t.id === 1)!,
  ALL_TESTIMONIALS.find((t) => t.id === 7)!,
  ALL_TESTIMONIALS.find((t) => t.id === 9)!,
  ALL_TESTIMONIALS.find((t) => t.id === 6)!,
  ALL_TESTIMONIALS.find((t) => t.id === 3)!,
  ALL_TESTIMONIALS.find((t) => t.id === 4)!,
];
